import Navbar from './nav_dash';
import { Button, Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { Submit_DB, GET_mearged, CALCULATE } from '../../api';


function Dash() {
  let user = JSON.parse(localStorage.getItem("userDetails")).userid;
  
  const [have, setHave] = useState([]);
  const [conferm, setConferm] = useState([]);
  const [done, setDone] = useState(false);
  const [data, setdata] = useState([]);
  const [placed,setPlaced] = useState(true);
  const [order_id,setOrderid] = useState();
  
  const initialise = () => {

    fetch(CALCULATE,{method:"post"})
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      return Promise.reject(response);;
    })
    .then((res) => {
      res.map((i) => {
        i.actual_price = 0;
        i.quantity = 0;
      })
      setdata(res);
    });
  }

  useEffect(() => {
    initialise();
}, [])

  function removeItem(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect){
        have.push(row.id);
      } else{
        setHave(removeItem(have, row.id));
      }
    },
    onSelectAll: (isSelect, rows, e) => {
      if(isSelect){
        rows.forEach(r => {
          have.push(r.id);
        });
      } else{
        setHave([]);
      }
    }
  };

  const buttonClick = () =>{
    have.map((id) => {
      data.map((i => {
        if(i.id == id){
          conferm.push(i);
        }
      }))
    });
    setdata(conferm);
    setDone(!done);
  };

  const conf = () =>{
    let final = {account:user,products:conferm};

    fetch(Submit_DB,{
      method : "post",
      headers : {"Content-Type": 'application/json'},
      body : JSON.stringify(final)
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return Promise.reject(response);;
    })
    .then((res) => {
      console.log(res);
      setPlaced(false);
      setOrderid(res);
    })
    .catch((e) => console.log(e));

  };

  const back = () =>{
    setConferm([]);
    initialise();
    setDone(!done);
  };

  const columns = [{
    dataField: 'id',
    text: 'Product ID',
    editable: false,
  }, {
    dataField: 'title',
    text: 'Product Name',
    editable: false,
    sort: true
  },{
    dataField: 'manufacturer',
    text: 'Manufacturer',
    editable: false,
    sort: true
  },{
    dataField: 'totalQuantity',
    text: 'Requred Quantity',
    editable:false,
    sort: true
  }, {
    dataField: 'quantity',
    text: 'quantity',
    sort: true
  },{
    dataField: 'actual_price',
    text: 'Price',
    editable: true,
    sort: true
  }];

  


  return (
    <>
    <Navbar/>
    <BootstrapTable keyField='id' 
    data={ data } 
    columns={ columns } 
    cellEdit={ cellEditFactory({ mode: 'click' }) }
    selectRow={selectRow}
    striped
    hover/>
    <Flex placeContent={"center"}>
      {done 
        ?<>
          <Button marginEnd={50} alignContent={"center"} bgColor={"#5e17eb"} color="white" textTransform={"uppercase"} onClick={ () => back()}>Back</Button>
          <Button marginStart={20} alignContent={"center"} bgColor={"#5e17eb"} color="white" textTransform={"uppercase"} onClick={ () => conf()}>Confirm</Button>
         </> 
        :<Button alignContent={"center"} bgColor={"#5e17eb"} color="white" textTransform={"uppercase"} onClick={ () => buttonClick()}>Done</Button>
      } 
    </Flex>
    {<Text display={"Flex"} placeContent={"center"} marginTop={"10px"} hidden={placed}>Supply request confirmed id: {order_id} </Text>}
    </>
  )
}

export default Dash;